export default {"src":"/_next/static/media/covered_loan_insurance.56a72948.svg","height":60,"width":63,"blurWidth":0,"blurHeight":0};